import { disablePageScroll, enablePageScroll } from "./helpers";

document.addEventListener("DOMContentLoaded", () => {
  const toggleSearch = document.querySelector(".js-toggle-search");
  const searchBar = document.querySelector(".js-header-search");

  if (toggleSearch && searchBar) {
    toggleSearch.addEventListener("click", (event) => {
      event.stopPropagation();
      event.preventDefault();

      toggleSearch.classList.toggle("toggled");
      searchBar.classList.toggle("open");
    });
  }

  const nav = document.getElementById("js-navigation");
  const navToggle = document.querySelector(".js-navigation-toggle");
  const closeNav = document.querySelector(".js-close-nav");

  if (navToggle && nav && closeNav) {
    navToggle.addEventListener("click", (event) => {
      event.stopPropagation();
      event.preventDefault();

      if (!nav.classList.contains("open")) {
        disablePageScroll();
        nav.classList.add("open");
      }
    });
    closeNav.addEventListener("click", (event) => {
      event.stopPropagation();
      event.preventDefault();

      if (nav.classList.contains("open")) {
        enablePageScroll();
        nav.classList.remove("open");

        if (window.matchMedia("(max-width: 1279px)").matches) {
          const activeToggles = nav.querySelectorAll(
            ".js-toggle-submenu.toggled"
          );
          const activeSubmenus = nav.querySelectorAll(".js-active-submenu");

          activeToggles.forEach((toggle) => {
            toggle.classList.remove("toggled");
          });
          activeSubmenus.forEach((submenu) => {
            hideSubmenu(submenu);
          });
        }
      }
    });
  }

  // set the active submenu to 0
  let activeSubmenu = 0;

  const toggleSubmenu = Array.from(
    document.getElementsByClassName("js-toggle-submenu")
  );

  if (toggleSubmenu.length) {
    toggleSubmenu.forEach(function (item) {
      const submenuID = item.getAttribute("data-submenu");
      const submenu = document.querySelector(`.js-submenu--${submenuID}`);

      item.addEventListener("click", (event) => {
        event.stopPropagation();
        event.preventDefault();

        item.classList.toggle("toggled");

        if (window.matchMedia("(max-width: 1279px)").matches) {
          if (item.classList.contains("toggled")) {
            submenu.style.maxHeight = `${submenu.scrollHeight}px`;
            submenu.style.opacity = 1;
            submenu.classList.add("js-active-submenu");
          } else {
            hideSubmenu(submenu);
          }
        } else {
          if (activeSubmenu > 0 && activeSubmenu !== submenuID) {
            closeActiveSubmenu();
          }

          submenu.classList.toggle("toggled");

          // set the active submenu ID
          if (submenu.classList.contains("toggled")) {
            activeSubmenu = submenuID;
          } else {
            activeSubmenu = 0;
          }
        }
      });
    });
  }

  // Close submenu on close button click event
  const closeSubmenu = Array.from(
    document.getElementsByClassName("js-close-submenu")
  );
  if (closeSubmenu.length) {
    closeSubmenu.forEach(function (e) {
      e.addEventListener("click", () => {
        closeActiveSubmenu(true);
      });
    });
  }

  function hideSubmenu(submenu) {
    submenu.style.maxHeight = 0;
    submenu.style.opacity = 0;
    submenu.classList.remove("js-active-submenu");
  }

  // Close submenu on "esc" keydown event
  document.addEventListener("keydown", function (event) {
    if (event.key === "Escape") {
      closeActiveSubmenu(true);
    }
  });

  if (window.matchMedia("(min-width: 1024px)").matches) {
    // Close submenu when clicking outside of the submenu
    document.addEventListener("click", function () {
      closeActiveSubmenu(true);
    });
  }

  /**
   * Close the active submenu
   */
  function closeActiveSubmenu(reset = false) {
    if (activeSubmenu === 0) {
      return;
    }

    const submenu = document.querySelector(`.js-submenu--${activeSubmenu}`);
    const toggle = document.querySelector(
      `.js-toggle-submenu[data-submenu="${activeSubmenu}"]`
    );

    if (submenu && toggle) {
      submenu.classList.remove("toggled");
      toggle.classList.remove("toggled");
    }

    // reset the active submenu ID to 0 if
    // the use has not toggled another submenu
    if (reset) {
      activeSubmenu = 0;
    }
  }
});
